import axios from 'axios';
import { TABLE_QR_ENDPOINT } from '@dynameat/constants';

export const tableQrListRequest = (point_of_sale__guid) => axios.get(
  TABLE_QR_ENDPOINT(), { params: { point_of_sale__guid, page_size: 0 } }
);

export const createTableQrRequest = (tableQr) => axios.post(TABLE_QR_ENDPOINT(), tableQr, { headers: { 'content-type': 'application/json' } });

export const editTableQrRequest = (tableQrGuid, data) => axios.patch(TABLE_QR_ENDPOINT(tableQrGuid), data, { headers: { 'content-type': 'application/json' } });

export const deleteTableQrRequest = (tableQrGuid) => axios.delete(TABLE_QR_ENDPOINT(tableQrGuid));
